import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const PagosRow=({pagos, onShowModalBorrar, onShowModalActivar, color,form, permisos})=>{
    return (
    <Table.Row>
                        <Table.Cell>{pagos.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{pagos.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
                                    <Link to={"/pagos/"+pagos.id}> 
                                     <Popup
                                        trigger={<Icon  name='edit outline' link   size="large"  color="tela" ></Icon>}
                                        content='Editar'
                                       
                                      />
                                     </Link> 
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(pagos.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={pagos.idEstatus==1?'x':'check'} link  size="large" 
                                                color={pagos.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(pagos.id)} 
                                            />
                                        }
                                        content={pagos.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default PagosRow;